import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { authService } from "../../../helpers/services/Auth";
import useAuth from "../../../hooks/useAuth";
import { redirectToAppsPortalIfEnabled } from "../../../shared/auth/lib/appsPortal";

export const useConexPage = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Sin sesión válida: al portal de apps si la integración está activa,
    // si no al login propio.
    const exitWithoutSession = () => {
      if (redirectToAppsPortalIfEnabled()) {
        return;
      }

      navigate("/login", { replace: true });
    };

    const loadSessionFromUuid = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const uuid = queryParams.get("uuid");

      if (!uuid) {
        console.error("No se encontró el token en la URL.");
        exitWithoutSession();
        return;
      }

      try {
        const response = await authService.conex({ uuid }).then((data) => data);

        if (!response.access && !response.refresh) {
          exitWithoutSession();
          return;
        }

        setAuth(response);
        window.dispatchEvent(new Event("authUpdated"));

        setTimeout(() => {
          navigate("/admin", { replace: true });
        }, 1500);
      } catch (error) {
        console.error("No se encontró el token en la URL.");
        exitWithoutSession();
      }
    };

    loadSessionFromUuid();
  }, [navigate, setAuth]);
};
